import ProductSizeTileList from './product-size-tile-list';

export default ProductSizeTileList;
